module.exports = __webpack_public_path__ + "img/vivint_logo.def7cc75.svg";